import { gql } from '@apollo/client';

export const FETCH_AVATAR = gql`
 query FetchAvatar {
    fetchAvatar {
        error {
            field
            message
            code
        }
        data {
            avatars {
                avatar_image_url
                id
            }
        }
    }
}
`;


